require('./angular-resource');
module.exports = 'ngResource';



//////////////////
// WEBPACK FOOTER
// ./~/angular-resource/index.js
// module id = 133
// module chunks = 0